import { useState, useEffect,useLayoutEffect } from "react";
import { QUICK_PRICER_FORM_CONFIG } from "../quickPricer.form.config";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormField,
  setFormData,
} from "../../../features/quickPricer/quickPricerFormSlice";

export const useQuickPricerForm = () => {
  const { sections } = QUICK_PRICER_FORM_CONFIG;

  const dispatch = useDispatch();
  const formState = useSelector(
    (state) => state.quickPricerForm.formData
  );

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  // Simple Redux setter
  const setFormState = (updater) => {
    const updated =
      typeof updater === "function" ? updater(formState) : updater;

    dispatch(setFormData({ ...formState, ...updated }));
  };


  // Computed & dynamic logic ONLY
  useEffect(() => {
    let computedFields = {};

    sections.forEach((section) => {
      section.fields.forEach((field) => {
        // Computed fields
        if (field.computed && typeof field.compute === "function") {
          const newValue = field.compute(formState);
          if (formState[field.name] !== newValue) {
            computedFields[field.name] = newValue;
          }
        }
      });
    });

    if (Object.keys(computedFields).length > 0) {
      dispatch(setFormData({ ...formState, ...computedFields }));
    }
  }, [formState, sections, dispatch]);

  //  Validation
  const validateForm = () => {
    const newErrors = {};

    sections.forEach((section) => {
      section.fields.forEach((field) => {
        const isRequired =
          typeof field.required === "function"
            ? field.required(formState)
            : field.required;

        const value = formState[field.name];

        if (
          isRequired &&
          (value === "" ||
            value === null ||
            value === undefined ||
            (Array.isArray(value) && value.length === 0))
        ) {
          newErrors[field.name] = `${field.label} is required`;
        }
      });
    });

    return newErrors;
  };

  return {
    formState,
    setFormState,
    errors,
    setErrors,
    submitted,
    setSubmitted,
    validateForm,
    sections,
  };
};